import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import Popup from './Popup';

storiesOf('Common/Popup', module)
  .add('View', () => (
    <Popup show={true}
           clsName="some-class-name"
           topBarTitle="Sample Popup"
           onClose={ action('OnClose') }>
      <div> Sample Popup Children Area </div>
    </Popup>
  ));




// WEBPACK FOOTER //
// ./src/components/common/Popup.stories.jsx